module.exports = __webpack_public_path__ + "img/xl.9da1e1da.png";